import React from 'react'
import {BaseIcon, type IconProps} from './icon-base'

export const LocationIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 21s6-5.33 6-11a6 6 0 1 0-12 0c0 5.67 6 11 6 11Z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
    </BaseIcon>
)

export const ExternalLinkIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 4h6v6" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m10 14 10-10" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4" />
    </BaseIcon>
)

export const InfoIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.25 11.25h1.5v4.5h1.5m-3-7.5h.008v.008h-.008V7.5z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z" />
    </BaseIcon>
)

export const DotsVerticalIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <circle cx="12" cy="5" r="1.5" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="19" r="1.5" fill="currentColor" stroke="none"/>
    </BaseIcon>
)

export const UserIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 21a8 8 0 0 0-16 0" />
        <circle cx="12" cy="8" r="4" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
    </BaseIcon>
)

export const ChevronRightIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </BaseIcon>
)

export const ChevronLeftIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </BaseIcon>
)

export const ChevronDownIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </BaseIcon>
)
